interface Props {
  onKeyDown(key: string): void
  onKeyUp(key: string): void
}

const KeyCapturer = ({ onKeyDown, onKeyUp }: Props) => {
  window.addEventListener('keydown', (event: KeyboardEvent) => {
    if (event.defaultPrevented) {
      return
    }

    onKeyDown(event.key)
  })

  window.addEventListener('keyup', (event: KeyboardEvent) => {
    onKeyUp(event.key)
  })

  return null
}

export default KeyCapturer



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/KeyCapturer.tsx